import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import { MenuItem, FormControl, Select } from "@mui/material";
import { marginBottom } from "../App";
import { Modal } from "react-bootstrap";
import Button from "@mui/material/Button";

const SelectUser = ({ onValueChange, itemId }) => {
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [selectedId, setSelectedId] = useState();
  const [confirm, setConfirm] = useState(false);
  const [obj, setObj] = useState({});

  const handleClose = () => setShow(false);

  useEffect(() => {
    const fetchData = async () => {
      const url = API_URL + `/groupsusers/${userData.cookie}/${userData.grpId}`;
      try {
        const response = await axios.get(url);
        // console.log(response.data);
        setData(response.data);
      } catch (error) {
        setError(error.message);
      }
    };

    if (userData && userData.userId && userData.grpId) {
      fetchData();
      const intervalId = setInterval(fetchData, 100000);
      return () => clearInterval(intervalId);
    }
  }, [userData, selectedId]);

  const handleConfirm = () => {
    setConfirm(true);
    onValueChange(obj);
    setShow(false);
  };

  const handleSelectChange = (event) => {
    //console.log(event.target.value);
    setObj({ value: event.target.value, id: itemId });
    //onValueChange({ value: event.target.value, id: itemId });
    setShow(true);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potwierdzenie zmiany właściciela zadania</Modal.Title>
        </Modal.Header>
        <Modal.Body>Przenieść zadanie?</Modal.Body>
        <Modal.Body>
          <Form>
            <Form.Group
              className="mb-3"
              controlId="closedComment.ControlInput1"
            ></Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={handleClose}>
            Anuluj
          </Button>
          <Button variant="contained" onClick={handleConfirm}>
            Tak - przenoszę
          </Button>
        </Modal.Footer>
      </Modal>

      <Container>
        <Form>
          <Row style={{ marginBottom }}>
            <Col>
              <FormControl fullWidth variant="outlined" sx={{ height: 15 }}>
                <Select
                  labelId="selectUser"
                  id="selectUser"
                  label="Wybierz użytkownika"
                  value={selectedId || ""}
                  onChange={handleSelectChange}
                  sx={{ height: 30, fontSize: 14 }}
                >
                  {data.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.fullName} [{user.user}]
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
};

export default SelectUser;
